<template>
    <div>
      <menu-nossa :lang="lang" :actRoute="actRoute" :isMobile="isMobile"></menu-nossa>
        <main id="main" >


          <div class="preloader">
            <Icons :id="'loading'"></Icons>

          </div>

          <transition name="fade">
            <home :lang="lang" :isMobile="isMobile" v-if="$route.name == 'home'"></home>

          </transition>
          <transition name="fade"  v-if="$route.name == 'home'">   <lat-nav></lat-nav> </transition>
          <transition name="fade">
            <project v-if="$route.name == 'project'" :lang="lang" :isMobile="isMobile"></project>
          </transition>
          <!--transition name="fade">
               <work  v-if="$route.name == 'work'" :lang="lang" :isMobile="isMobile" :actRoute="actRoute"></work>
          </transition-->
          <transition name="fade">
          <ideia  v-if="$route.name == 'work'" :lang="lang" :isMobile="isMobile" :actRoute="actRoute"></ideia>
          </transition>

          <transition name="fade">
            <about  v-if="$route.name == 'agency'" :lang="lang" :isMobile="isMobile"></about>
          </transition>


          <transition name="fade">
            <culture v-if="$route.name == 'culture'" :lang="lang" :isMobile="isMobile"></culture>

          </transition>

          <transition name="fade">
            <brands v-if="$route.name == 'brands'" :lang="lang" :isMobile="isMobile"></brands>
          </transition>


          <transition name="fade">

            <contact v-if="$route.name == 'contact'" :lang="lang" :isMobile="isMobile">

            </contact>

          </transition>


          <transition name="fade">


              <choca v-if="$route.name == 'choca'"> </choca>



          </transition>

          <transition name="fade">

            <contact v-if="$route.name == 'kamlas'" :lang="lang" :isMobile="isMobile">

            </contact>

          </transition>



        </main>





    </div>

</template>

<script>


    import {EVENTBUS} from '../main';
    import MenuNossa from "./MenuNossa";
    import {PATH, WP} from '../main';
    import Home from "./Home";
    import FooterNossa from "./FooterNossa";
    import LatNav from "./Modules/LatNav";
    import Project from "./Project";
    import Work from "./Work";
    import About from "./About";
    import Culture from "./Culture";
    import Contact from "./Contact";
    import Brands from "./Brands";
    import Icons from "./Modules/icons";
    import Ideia from "./Ideia";
    import Choca from "./Choca";




    export default {

        name: 'Desktop',
        components: {
          Choca,
          Ideia,
          Icons,
          Brands,
          Contact,
          Culture,
          About,
          Work,
          Project,
          LatNav,
          FooterNossa,
          Home,
          MenuNossa


           },
        props: ['route', 'lang', 'isMobile'],
        watch: {
            '$route' (to, from) {

                console.log('to: ' + to.path);
                //console.log('from: ' + from.path);

                this.changeRoute({to: to.name, from: from.name})

            }
        },
        data() {
            return {
                preloader: true,
                haveMenu: false,
                wheelAvailable: false,
                currentScreen: 0,
                requestScreen: 0,
                actRoute: this.$route,
                wasHome: false,

            }
        },

        created() {











        },
        mounted() {



        },

        destroyed() {

        },

        methods: {

            init() {


            },

            removePreloader() {
                this.preloader = false;

            },


            wheelEVT(e) {

                /*

                if(this.wheelAvailable) {
                    if(e.deltaY > 2 || e.deltaX > 2) {
                        this.whellSwitch(false);
                        this.evtNavigation(1, e);
                    }else if(e.deltaY < -2 || e.deltaX < -2) {
                        this.whellSwitch(false);
                        this.evtNavigation(0, e);
                    }
                }

                */

            },






            removeScreen() {

                switch (this.currentScreen) {
                    case 0:
                        break;
                }
            },


            insertScreen() {

            },

            findRoute(s){
                var b = false;

                if(this.$route.path == ('/' + s)){
                    b = true;
                }else{
                    b =  false;
                }

                return b;
            },





            changeRoute(obj) {





              console.log('changeRoute')

                switch (obj.to) {

                    case 'home':



                        break;


                }
            },




            setRoute(route) {


              console.log('setRoute')

               if(route == 'home') {
                   this.wasHome = true;
               }

                this.actRoute = route;




            },

            removeRoute(route) {
                this.actRoute = route;

              console.log('removeRoute')
                /*
                if(route == 'detail') {
                    EVENTBUS.$emit('manager-detail', 'init');
                    EVENTBUS.$emit('manager-activities', 'show-detail');
                }else{

                }


                 */

            },


        },
    };

</script>

<style lang="sass">


    //@media all and (min-width: 0px) and (max-width: 800px){ }

    @import "../assets/sass/main.scss";



</style>


// WEBPACK FOOTER //
// src/components/Desktop.vue